var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.59 6.5H10V1.5C10 0.95 9.55 0.5 9 0.5H5C4.45 0.5 4 0.95 4 1.5V6.5H2.41C1.52 6.5 1.07 7.58 1.7 8.21L6.29 12.8C6.68 13.19 7.31 13.19 7.7 12.8L12.29 8.21C12.92 7.58 12.48 6.5 11.59 6.5ZM0 16.5C0 17.05 0.45 17.5 1 17.5H13C13.55 17.5 14 17.05 14 16.5C14 15.95 13.55 15.5 13 15.5H1C0.45 15.5 0 15.95 0 16.5Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.0c38193f984cdc78f36967c219d71590.svg";
export { ForwardRef as ReactComponent };